import React from 'react';
import PropTypes from 'prop-types';
import '../styles/VerificationBadge.css';

const VerificationBadge = ({ verificationStatus, size = 'small' }) => {
  if (!verificationStatus) {
    return null;
  }

  const { verified_email, verified_phone, verified_id } = verificationStatus;
  const badges = [];

  // Email verification badge
  if (verified_email) {
    badges.push({
      type: 'email',
      icon: '✉️',
      label: 'Email Verified',
      color: 'green'
    });
  }

  // Phone verification badge
  if (verified_phone) {
    badges.push({
      type: 'phone',
      icon: '📱',
      label: 'Phone Verified',
      color: 'blue'
    });
  }

  // ID verification badge
  if (verified_id) {
    badges.push({
      type: 'id',
      icon: '🆔',
      label: 'ID Verified',
      color: 'purple'
    });
  }

  // Don't render anything if no verifications
  if (badges.length === 0) {
    return null;
  }

  return (
    <div className={`verification-badges ${size}`}>
      {badges.map((badge, index) => (
        <span
          key={badge.type}
          className={`verification-badge ${badge.color}`}
          title={badge.label}
        >
          <span className="badge-icon">{badge.icon}</span>
          {size !== 'small' && (
            <span className="badge-label">{badge.label}</span>
          )}
        </span>
      ))}
    </div>
  );
};

VerificationBadge.propTypes = {
  verificationStatus: PropTypes.shape({
    verified_email: PropTypes.bool,
    verified_phone: PropTypes.bool,
    verified_id: PropTypes.bool
  }),
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};

export default VerificationBadge; 